export default __webpack_public_path__ + "static/media/(5)-Chocolate-en-rama.3b95ad16.jpg";